import modelBaseV2 from "../model-base-v2.model";

/**
 * Fixture Master Model
 * 
 * This feature is for admin register fixtures.
 * 
 * @author Molly Liu
 */

const fixtureModel = {
  getFixtureList: (params) => {
    const qs = modelBaseV2.toQueryString(params);
    return modelBaseV2.get(`/api/planogram/fixture/lists?${qs}`, {});
  },
  updateFixture: (body) => {
    return modelBaseV2.post('/api/planogram/fixture/update', { body });
  },
  saveFixture: (body, abortable) => {
    return modelBaseV2.post('/api/planogram/fixture/create', body, abortable);
  },
  downloadFixture: (filename, body) => {
    return modelBaseV2.postDownload('/api/planogram/fixture/lists/download', {body}, filename);
  }
}

export default fixtureModel;
